<template>
  <div class='sub-page sub-page-leftmenu'>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <ResizeRow :sliderWidth="3" width="100%" :height="gridHeight" style="padding-bottom:1px;">
        <div class='applicant-grid' style="height:100%">
          <dx-data-grid ref='refApplicantnGrid'
            :remote-operations="true"
            :data-source='applicantInfoList'
            :show-borders = 'true' :showRowLines = 'true' :showColumnLines='true'
            :hover-state-enabled = "true" :allowColumnResizing = 'true'
            column-resizing-mode = 'widget' :allow-column-reordering = "true"
            height='100%' :row-alternation-enabled="true" keyExpr="seqId"
            :focusedRowEnabled="false" :focused-row-key.sync='focusedRowKey'
            :auto-navigate-to-focused-row="false" @selection-changed="onFocusedRowChanged"
            @editor-preparing='onEditorPreparing' @toolbarPreparing="onToolbarPreparing"
            @init-new-row='onInitNewRow' @exporting="onExcelExporting"
            @rowDblClick ='onRowDbClick' @contentReady="onContentReady"
          >
            <DxSelection mode="single"/>
            <DxSearchPanel
              :visible="false"
              placeholder="검색..."
            />
            <DxExport
              :enabled="true"
            />
            <DxFilterRow
              :visible="true"
              apply-filter="auto"
            />
            <DxStateStoring
              :enabled="false"
              type="localStorage"
              storage-key="applicant"
            />
            <DxEditing
              :allow-deleting="isCRUD"
              :allow-updating="isCRUD"
              :allow-adding="true"
              :use-icons="true"
              mode='popup'
            >
              <DxPopup
                :show-title="true"
                :width="900"
                :height="910"
                title="후보자 등록"
              >
                <dx-position
                  my="center"
                  at="center"
                  of="window"
                />
              </DxPopup>
              <DxForm>
                <DxItem
                  :col-count="2"
                  :col-span="2"
                  item-type="group"
                  caption="기본정보"
                >
                  <DxItem data-field="성명"/>
                  <DxItem data-field="성별"/>
                  <DxItem data-field="생년월일"/>
                  <DxItem data-field="최종학력"/>
                  <DxItem data-field="졸업여부"/>
                  <DxItem data-field="최종학교명"/>
                  <DxItem data-field="학교소재지"/>
                  <DxItem data-field="전문학사편입정보"/>
                  <DxItem data-field="전공"/>
                  <DxItem data-field="입학년도"/>
                  <DxItem data-field="부전공"/>
                  <DxItem data-field="졸업년도"/>
                </DxItem>
                <DxItem
                  :col-count="2"
                  :col-span="2"
                  item-type="group"
                  caption="경력정보"
                >
                  <DxItem data-field="경력연수"/>
                  <DxItem data-field="최종회사명"/>
                  <DxItem data-field="재직여부"/>
                  <DxItem data-field="직위"/>
                  <DxItem data-field="대표회사"/>
                  <DxItem data-field="현재연봉"/>
                  <DxItem data-field="희망연봉"/>
                </DxItem>
                <DxItem
                  :col-count="2"
                  :col-span="2"
                  item-type="group"
                  caption="기타정보"
                >
                  <DxItem data-field="외국어1"/>
                  <DxItem data-field="외국어1등급"/>
                  <DxItem data-field="외국어2"/>
                  <DxItem data-field="외국어2등급"/>
                  <DxItem data-field="자격증1"/>
                  <DxItem data-field="자격증2"/>
                  <DxItem data-field="자격증3"/>
                  <DxItem data-field="경력키워드"/>
                  <DxItem data-field="이력서입수경로"/>
                  <DxItem data-field="이메일"/>
                  <DxItem data-field="연락처"/>
                  <DxItem data-field="컨설턴트"/>
                  <DxItem v-if="isAdmin" data-field="remark"/>
                </DxItem>
            </DxForm>
            </DxEditing>
            <DxColumnFixing :enabled="true"/>
            <DxColumn
            :allowEditing="false"
            :visible="false"
            caption="ID"
            data-field="seqId"
            dataType="number"
            :min-width="50"
            :fixed="true"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="isIdEdit"
            :visible="true"
            caption="성명"
            data-field="성명"
            alignment="center"
            :min-width="80"
            :fixed="true"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
              caption="기본정보"
            >
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="성별"
              data-field="성별"
              alignment="center"
              :min-width="60"
              >
                <DxLookup
                  :data-source="manWoomanLookup"
                  display-expr="코드명"
                  value-expr="코드명"
                />
                <DxRequiredRule message="항목을 입력하세요"/>
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="경력키워드"
              data-field="경력키워드"
              alignment="center"
              :min-width="300"
              >
              </DxColumn>

              <DxColumn
                :allowEditing="true"
                :visible="false"
                caption="생년월일"
                data-field="생년월일"
                alignment="center"
                format="yyyy-MM-dd"
                dataType="date"
                :min-width="100"
              >
                <DxRequiredRule message="항목을 입력하세요"/>
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="나이"
              :calculate-cell-value="calculateAge"
              dataType="number"
              :min-width="60"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="최종학력"
              data-field="최종학력"
              alignment="center"
              :min-width="80"
              >
                <DxLookup
                  :data-source="studyLookup"
                  display-expr="코드명"
                  value-expr="코드명"
                />
                <DxRequiredRule message="항목을 입력하세요"/>
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="졸업여부"
              data-field="졸업여부"
              alignment="center"
              :min-width="100"
              >
                <DxLookup
                  :data-source="graduateLookup"
                  display-expr="코드명"
                  value-expr="코드명"
                />
                <DxRequiredRule message="항목을 입력하세요"/>
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="최종학교명"
              data-field="최종학교명"
              alignment="left"
              :min-width="100"
              >
                <DxRequiredRule message="항목을 입력하세요"/>
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="전문학사편입정보"
              data-field="전문학사편입정보"
              alignment="left"
              :min-width="100"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="학교소재지"
              data-field="학교소재지"
              alignment="left"
              :min-width="100"
              >
                <DxRequiredRule message="항목을 입력하세요"/>
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="전공"
              data-field="전공"
              alignment="center"
              :min-width="120"
              >
                <DxRequiredRule message="항목을 입력하세요"/>
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="부전공"
              data-field="부전공"
              alignment="center"
              :min-width="120"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="입학년도"
              data-field="입학년도"
              alignment="center"
              dataType="number"
              :min-width="80"
              >
                <DxRequiredRule message="항목을 입력하세요"/>
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="졸업년도"
              data-field="졸업년도"
              alignment="center"
              dataType="number"
              :min-width="80"
              >
              </DxColumn>
            </DxColumn>
            <DxColumn
              caption="경력 정보"
            >
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="경력(년))"
              data-field="경력연수"
              format="#,##0"
              dataType="number"
              :min-width="70"
              >
                <DxRequiredRule message="항목을 입력하세요"/>
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="최종회사명"
              data-field="최종회사명"
              alignment="left"
              :min-width="100"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="재직여부"
              data-field="재직여부"
              alignment="center"
              :min-width="80"
              >
                <DxLookup
                  :data-source="재직여부Lookup"
                  display-expr="코드명"
                  value-expr="코드명"
                />
                <DxRequiredRule message="항목을 입력하세요"/>
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="직위"
              data-field="직위"
              alignment="center"
              :min-width="80"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="대표회사"
              data-field="대표회사"
              alignment="left"
              :min-width="100"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="현재연봉(만)"
              data-field="현재연봉"
              :min-width="100"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="희망연봉"
              data-field="희망연봉"
              :min-width="100"
              >
                <DxRequiredRule message="항목을 입력하세요"/>
              </DxColumn>
            </DxColumn>
            <DxColumn
              caption="기타 정보"
            >
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="1외국어회화"
              data-field="외국어1"
              alignment="center"
              :min-width="80"
              >
                <DxLookup
                  :data-source="languageLookup"
                  display-expr="코드명"
                  value-expr="코드명"
                />
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="1외국어자격증"
              data-field="외국어1등급"
              alignment="center"
              :min-width="60"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="2외국어회화"
              data-field="외국어2"
              alignment="center"
              :min-width="80"
              >
                <DxLookup
                  :data-source="languageLookup"
                  display-expr="코드명"
                  value-expr="코드명"
                />
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="2외국어자격증"
              data-field="외국어2등급"
              alignment="center"
              :min-width="60"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="자격증1"
              data-field="자격증1"
              alignment="center"
              :min-width="110"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="자격증2"
              data-field="자격증2"
              alignment="center"
              :min-width="110"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="자격증3"
              data-field="자격증3"
              alignment="center"
              :min-width="110"
              >
              </DxColumn>

              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="컨설턴트"
              data-field="컨설턴트"
              alignment="center"
              :min-width="80"
              >
                <DxLookup
                  :data-source="employeeInfo"
                  display-expr="성명"
                  value-expr="사번"
                />
                <DxRequiredRule message="항목을 입력하세요"/>
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="이력서입수경로"
              data-field="이력서입수경로"
              alignment="center"
              :min-width="100"
              >
                <DxRequiredRule message="항목을 입력하세요"/>
                <DxLookup
                  :data-source="profileSourceLookup"
                  display-expr="코드명"
                  value-expr="코드명"
                />
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="이메일"
              data-field="이메일"
              alignment="left"
              :min-width="80"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="연락처"
              data-field="연락처"
              alignment="left"
              :min-width="80"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="false"
              caption="특이사항"
              data-field="remark"
              alignment="left"
              :min-width="80"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="사용유무"
              data-field="사용유무"
              alignment="center"
              :min-width="80"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="isExporing"
              caption="삭제유무"
              data-field="삭제유무"
              alignment="center"
              :min-width="80"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="작성자"
              data-field="createdId"
              alignment="center"
              :min-width="80"
              >
                <DxLookup
                  :data-source="employeeInfo"
                  display-expr="성명"
                  value-expr="사번"
                />
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="등록일"
              data-field="createdTime"
              alignment="center"
              format="yyyy-MM-dd"
              dataType="date"
              :min-width="100"
              >
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="수정자"
              data-field="updatedId"
              alignment="center"
              :min-width="80"
              >
                <DxLookup
                  :data-source="employeeInfo"
                  display-expr="성명"
                  value-expr="사번"
                />
              </DxColumn>
              <DxColumn
              :allowEditing="true"
              :visible="true"
              caption="수정일"
              data-field="updatedTime"
              alignment="center"
              format="yyyy-MM-dd"
              dataType="date"
              :min-width="100"
              sortOrder="desc"
              >
              </DxColumn>
            </DxColumn>
            <DxMasterDetail
              :enabled="true"
              template="masterDetailTemplate"
            />
            <DxSummary>
              <DxTotalItem
                value-format='#,##0'
                show-in-column="성명"
                display-format="{0} (건)"
              />
            </DxSummary>
            <dx-paging :enabled="true" :page-size="50"/>
            <DxPager
              :visible="true"
              :allowed-page-sizes="[1, 20, 30, 50, 100]"
              display-mode="full"
              :show-page-size-selector="true"
              :show-info="false"
              :show-navigation-buttons="true"
            />
            <dx-scrolling mode="standard" showScrollbar='always' :useNative='false'/>
            <dx-sorting mode="single"/>
            <template #masterDetailTemplate="{ data }">
              <div style="margin-top: 0px;padding: 0;">
                <ApplicantDetailPositionComponent :dataSource="data.data"/>
              </div>
            </template>
          </dx-data-grid>
        </div>
      </ResizeRow>
      <div class="detail-wrap">
        <div class="detail-title" style="margin-bottom: 8px;margin-top: 40px;">{{ applicantDetail }}</div>
        <div class='sub-tab-wrap'>
          <DxTabPanel
              id="tabpanel"
              :selected-index.sync="selectedIndex"
              :data-source='tabs'
              :focusStateEnabled='true'
            >
            <template #title="{ data: tab }">
              <div class='sub-title-wrap-tab'>
                <ul>
                  <li class='float-left sub-title'>{{tab.title}}</li>
                </ul>
              </div>
            </template>
          </DxTabPanel>
          <div v-if='selectedIndex === 0'>
            <div style="margin-top: 20px;padding: 0 20px; display:flex">
              <table class="table-bordered" style="width:33%;">
                <colgroup>
                  <col width="25%">
                  <col width="">
                </colgroup>
                <tbody>
                  <tr style="">
                    <th scope="row">이름</th>
                    <td >
                      {{ selectedRow.성명 }}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">총경력</th>
                    <td >
                      {{ selectedRow.경력연수 }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">최종학교명</th>
                    <td >
                      {{ selectedRow.최종학교명}}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">대표회사</th>
                    <td >
                      {{ selectedRow.대표회사}}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">경력키워드</th>
                    <td >
                      {{ selectedRow.경력키워드 }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table-bordered" style="width:33%;margin-right:0%">
                <colgroup>
                  <col width="25%">
                  <col width="">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">생년월일</th>
                    <td >
                      {{ selectedRow.생년월일 | date }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">최종학교명</th>
                    <td >
                      {{ selectedRow.최종학교명}}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">직위</th>
                    <td >
                      {{ selectedRow.직위}}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">외국어</th>
                    <td >
                      {{ selectedRow.외국어1 }}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">연락처</th>
                    <td >
                      {{ selectedRow.연락처 }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table-bordered" style="width:34%;margin-right:0%">
                <colgroup>
                  <col width="25%">
                  <col width="">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">성별</th>
                    <td >
                      {{ selectedRow.성별 }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">전공</th>
                    <td >
                      {{ selectedRow.전공 }}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">현재연봉</th>
                    <td >
                      {{ selectedRow.현재연봉}}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">자격증</th>
                    <td >
                      {{ selectedRow.자격증1 }}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">이메일</th>
                    <td >
                      {{ selectedRow.이메일 }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if='selectedIndex === 1' style="margin-top: 10px;padding:0 20px;">
          <FileUploadComponent :gridHeightFile="210" :fileListInfo="fileListInfo"
            :selectedParent="selectedRow" :fileType="지원자첨부파일" :parentKey="selectedRow.seqId"
          />
        </div>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxSelection, DxMasterDetail, DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxSummary, DxForm,
  DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxPopup, DxPosition, DxStateStoring, DxPager
} from 'devextreme-vue/data-grid'
import { DxItem } from 'devextreme-vue/form'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import { ResizeRow } from 'vue-resizer'
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
// Our demo infrastructure requires us to use 'file-saver-es'.
// We recommend that you use the official 'file-saver' package in your applications.
import { exportDataGrid } from 'devextreme/excel_exporter'
import FileUploadComponent from '../../share/component/FileUploadComponent.vue'
import CustomStore from 'devextreme/data/custom_store'
import DataSource from 'devextreme/data/data_source'
import HttpService from '../../share/service/HttpService'
import ApplicantDetailPositionComponent from './ApplicantDetailPositionComponent'

export default {
  name: 'applicant',
  data: function () {
    return {
      isLoading: false,
      selectedIndex: 0,
      editButtons: ['edit', 'delete'],
      applicantInfoList: null,
      gridHeight: null,
      userInfo: null,
      isIdEdit: true,
      selectedRow: {},
      focusedRowKey: null,
      tabs: [
        {
          title: '후보자 추가정보'
        },
        {
          title: '첨부파일 관리'
        }
      ],
      applicantDetail: '-추가정보',
      studyLookup: this.$store.getters.getBaseDataByType(ConstDef.최종학력),
      manWoomanLookup: ConstDef.남녀,
      graduateLookup: ConstDef.졸업여부,
      levelLookup: ConstDef.상중하,
      profileSourceLookup: this.$store.getters.getBaseDataByType(ConstDef.프로필입수경로),
      languageLookup: this.$store.getters.getBaseDataByType(ConstDef.외국어능력),
      재직여부Lookup: ConstDef.재직여부Lookup,
      employeeInfo: this.$store.getters.getEmployee,
      isExporing: false,
      pageSize: 50,
      queryStringSeqId: null,
      isAdmin: false,
      // File upload
      지원자첨부파일: ConstDef.지원자첨부파일,
      fileListInfo: null,
      calledContentReady: false
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxRequiredRule,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxPager,
    DxStateStoring,
    DxTotalItem,
    DxPopup,
    DxPosition,
    DxTabPanel,
    DxScrolling,
    DxForm,
    DxItem,
    ResizeRow,
    DxMasterDetail,
    DxSelection,
    ApplicantDetailPositionComponent,
    FileUploadComponent
  },
  computed: {
    getLanguage2 () {
      if (this.selectedRow.seqId !== undefined && this.selectedRow.외국어2 !== null) {
        return this.$_.findWhere(this.languageLookup, { 코드명: this.selectedRow.외국어2 }).코드명
      }
      return ''
    }
  },
  created () {
    console.log(screen.height)
    this.gridHeight = (screen.height - 150 - 70 - 370)
    this.gridHeightFile = 210
    console.log(this.employeeInfo)
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.queryStringSeqId = this.$route.query.seqId
    console.log(this.queryStringSeqId)
    this.refreshApplicant()
  },
  mounted () {
    if (this.queryStringSeqId !== undefined) {
      const headTitle = this.$store.getters.headTitleByPath(this.$_, this.$router.currentRoute.path)
      if (headTitle !== null) {
        this.$emit('titleFromChild', headTitle)
      } else {
        this.$emit('titleFromChild', this.$router.currentRoute.name)
      }
    }
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calculateAge (row) {
      if (row.생년월일 !== undefined) {
        return parseInt(this.$_appLib.getToday().substring(0, 4)) - parseInt(row.생년월일.substring(0, 4))
      }
    },
    isCRUD (e) {
      return (e.row.data.컨설턴트 === this.userInfo.userId ||
        this.userInfo.permission === ConstDef.SYSTEM_ADMIN)
    },
    onContentReady (e) {
      if (this.calledContentReady) return
      this.calledContentReady = true
      this.applicantInfoList._items.forEach(item => {
        if (this.userInfo.userId !== item.컨설턴트 && this.userInfo.permission !== ConstDef.SYSTEM_ADMIN) {
          item.이메일 = '****'
          item.연락처 = '****'
        }
      })
    },
    onEditorPreparing (e) {
      if (e.dataField === 'createdId' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    onFocusedRowChanged (e) {
      if (e.selectedRowsData.length === 0) return
      e.component.collapseAll(-1)
      if (e !== null) {
        this.selectedRow = e.selectedRowsData[0]
        this.showRemark(this.selectedRow)
        this.applicantDetail = `${this.selectedRow.성명} - 추가정보`
        this.refreshFileList()
      }
    },
    onExcelExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet('후보자정보')
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), '후보자정보.xlsx')
          this.isExporing = false
        })
      })
      e.cancel = true
    },
    onInitNewRow (row) {
      console.log(row)
      this.isAdmin = true
      row.data.컨설턴트 = this.userInfo.userId
    },
    showRemark (data) {
      if (this.userInfo.permission & ConstDef.CRUD_ALLOW_경영 ||
        data.컨설턴트 === this.userInfo.userId
      ) {
        this.isAdmin = true
      } else {
        this.isAdmin = false
      }
    },
    onRowDbClick (row) {
      this.showRemark(row.data)
      this.$refs.refApplicantnGrid.instance.editRow(row.rowIndex)
      setTimeout(() => {
        this.$Q('.dx-datagrid-edit-popup .dx-popup-bottom .dx-toolbar-after').hide()
      }, 100)
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          widget: 'dxCheckBox',
          options: {
            value: this.isExporing,
            text: '모든 컬럼 보기',
            focusStateEnabled: true,
            onValueChanged: (args) => {
              this.isExporing = args.value
            }
          }
        }
      )
    },
    refreshFileList () {
      if (this.selectedRow.seqId !== undefined) {
        this.$_sp.runFindSqlProc('첨부파일정보', { 파일유형: this.지원자첨부파일, 상위코드: this.selectedRow.seqId })
          .then(data => {
            this.fileListInfo = this.$_sp.MakeModel(data)
            console.log(this.fileListInfo)
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    },
    refreshApplicant () {
      const vue = this
      let store = new CustomStore({
        key: 'seqId',
        load (loadOptions) {
          const postParam = {}
          let isGroup = false
          const temp =
            [
              'skip',
              'take',
              'requireTotalCount',
              'requireGroupCount',
              'sort',
              'filter',
              'totalSummary',
              'group',
              'groupSummary'
            ]
          temp.forEach((key) => {
            if (key in loadOptions && vue.$_appLib.isNotEmpty(loadOptions[key])) {
              if (key === 'group') {
                isGroup = true
              }
              if (key === 'filter') {
                // console.log(loadOptions[key])
                const filterArray = []
                if (loadOptions[key][1] !== 'and') {
                  if (loadOptions[key][0] === 'createdTime' || loadOptions[key][0] === 'updatedTime') {
                    loadOptions[key][2] = vue.$_appLib.formatDate(loadOptions[key][2])
                  }
                  filterArray.push(loadOptions[key])
                } else {
                  loadOptions[key].forEach(item => {
                    if (Array.isArray(item) && Array.isArray(item[0])) {
                      item.forEach(row => {
                        // console.log(row)
                        if (Array.isArray(row) && (row[0] === 'createdTime' || row[0] === 'updatedTime')) {
                          row[2] = vue.$_appLib.formatDate(row[2])
                        }
                        if (Array.isArray(row)) filterArray.push(row)
                      })
                    } else {
                      if (item[0] === 'createdTime' || item[0] === 'updatedTime') {
                        item[2] = vue.$_appLib.formatDate(item[2])
                      }
                      if (Array.isArray(item)) filterArray.push(item)
                    }
                  })
                }
                postParam[key] = filterArray
              } else {
                postParam[key] = loadOptions[key]
              }
              // console.log(key, JSON.stringify(loadOptions[key]))
            }
          })
          if (isGroup) {
            let lookup = null
            if (postParam.group[0].selector === '성별') {
              lookup = vue.manWoomanLookup
            } else if (postParam.group[0].selector === '최종학력') {
              lookup = vue.studyLookup
            } else if (postParam.group[0].selector === '외국어1' || postParam.group[0].selector === '외국어2') {
              lookup = vue.languageLookup
            } else if (postParam.group[0].selector === '외국어1등급' || postParam.group[0].selector === '외국어2등급') {
              lookup = vue.levelLookup
            } else if (postParam.group[0].selector === '졸업여부') {
              lookup = vue.graduateLookup
            } else if (postParam.group[0].selector === '이력서입수경로') {
              lookup = vue.profileSourceLookup
            } else if (postParam.group[0].selector === 'createdId' ||
              postParam.group[0].selector === 'updatedId' ||
              postParam.group[0].selector === '컨설턴트'
            ) {
              lookup = vue.employeeInfo
            } else if (postParam.group[0].selector === '재직여부') {
              lookup = vue.재직여부Lookup
            }
            return HttpService.reqPostBody(lookup, '/getDevLookup')
              .then(rseponse => (
                {
                  data: JSON.parse(rseponse.data),
                  totalCount: rseponse.totalCount,
                  summary: [rseponse.totalCount]
                }
              ))
              .catch(() => { throw new Error('Data Loading Error') })
          } else {
            vue.calledContentReady = false
            if (vue.queryStringSeqId !== undefined) {
              if (postParam.filter === undefined) {
                postParam.filter = []
              }
              console.log(postParam.filter)
              postParam.filter.push(['seqId', '=', parseInt(vue.queryStringSeqId)])
              setTimeout(() => {
                vue.$refs.refApplicantnGrid.instance.selectRows(parseInt(vue.queryStringSeqId), true)
              }, 100)
            }
            if (vue.userInfo.permission === ConstDef.재택근무자) {
              if (postParam.filter === undefined) {
                postParam.filter = []
              }
              postParam.filter.push(['컨설턴트', '=', (vue.userInfo.userId)])
            }
            return vue.$_sp.runFindSqlDevCustomeProc('지원대상자', postParam)
              .then(rseponse => (
                {
                  data: JSON.parse(rseponse.data),
                  totalCount: rseponse.totalCount,
                  summary: [rseponse.totalCount]
                }
              ))
              .catch(() => { throw new Error('Data Loading Error') })
          }
        },
        insert: (values) => {
          if (values.외국어2 !== undefined && values.외국어2 === ConstDef.외국어무관) {
            values.외국어2 = null
            values.외국어2등급 = null
          }
          values.updatedTime = values.createdTime = vue.$_appLib.getNow()
          values.updatedId = values.createdId = vue.userInfo.userId
          return vue.$_sp.runInsertSqlProc('지원대상자', ['seqId'], [values])
            .then(reponce => {
              vue.$snotify.info('저장 되었습니다.')
            })
            .catch(() => { throw new Error('Insert Error') })
        },
        remove: (key) => {
          const param = { 'seqId': key }
          return vue.$_sp.runDeleteSqlProc('지원대상자', [param])
            .then(reponce => {
              vue.$snotify.info('삭제 되었습니다.')
            })
            .catch(() => { throw new Error('Delete Error') })
        },
        update: (key, values) => {
          vue.applicantInfoList.cancel()
          console.log('updated', key, values)
          values.seqId = key
          if (values.외국어2 !== undefined && values.외국어2 === ConstDef.외국어무관) {
            values.외국어2 = null
            values.외국어2등급 = null
          }
          return vue.$_sp.runUpdateSqlProc('지원대상자', ['seqId'], null, [values])
            .then(reponce => {
              vue.$snotify.info('변경 되었습니다.')
            })
            .catch(() => { throw new Error('Update Error') })
        },
        onUpdating: (key, values) => {
          console.log('updateing', key, values)
        }
      })
      this.applicantInfoList = new DataSource({ store: store })
    }

  }
}
</script>

<style lang="scss">
.table-bordered {
    width: 100%;
    margin-bottom: 0px;
    border:1px solid #acacac;
    border-collapse: collapse;
    th,td{
      border-bottom: 1px solid #acacac;
      border-right: 1px solid #acacac;
      padding: 6px;
    }
    th{
      background-color: rgb(239, 239, 239);;
    }
}
</style>
